<template>
  <div id="header" class="header">
    <div class="section size-10">
      <a id="logo" class="jrm-logo-svg white" href="/" style="left:initial; top:initial; position:relative"></a>
    </div>
    <div class="section size-60">
      <a class="pagelink" href="/">На главную</a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TheLogo'
}
</script>
